export const isCrCardProduct = (globalId: string) => globalId.startsWith('260000') || globalId.startsWith('270000')
